if (!customElements.get('pc-room-preview')) {
  customElements.define('pc-room-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('[data-ar-dialog]');
      this.trigger = this.querySelector('[data-ar-open]');
      this.status = this.querySelector('[data-ar-status]');
      this.launch = this.querySelector('[data-ar-launch]');
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-ar-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.trigger.focus({ preventScroll: true });
      }, options);
      this.launch.addEventListener('click', async () => {
        if (!this.viewer?.canActivateAR) return;
        try {
          await this.viewer.activateAR();
        } catch {
          this.status.textContent = this.status.dataset.error;
        }
      }, options);
      if (new URLSearchParams(location.search).get('pc_ar') === '1') this.open();
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.controller?.abort();
      this.controller = null;
      clearTimeout(this.loadTimer);
    }
    async open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (this.viewer) return;
      this.status.textContent = this.status.dataset.loading;
      const link = new URL(this.dataset.productUrl);
      link.searchParams.set('pc_ar', '1');
      if (this.dataset.previewTheme) link.searchParams.set('preview_theme_id', this.dataset.previewTheme);
      this.querySelector('[data-ar-mobile-link]').href = link.href;
      const mobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
      try {
        const qrPanel = this.querySelector('[data-ar-qr-panel]');
        if (mobile) qrPanel.hidden = true;
        else {
          const { QRCode } = await import(this.dataset.qrModule);
          const target = this.querySelector('[data-ar-qr]');
          target.replaceChildren();
          new QRCode(target, { text: link.href, width: 168, height: 168, correctLevel: QRCode.CorrectLevel.M });
        }
        if (!customElements.get('model-viewer')) await import(this.dataset.viewerModule);
        if (!this.isConnected) return;
        const fragment = this.querySelector('[data-ar-template]').content.cloneNode(true);
        const viewer = fragment.querySelector('model-viewer');
        viewer.removeAttribute('ios-src');
        viewer.removeAttribute('data-shopify-feature');
        viewer.setAttribute('loading', 'eager');
        viewer.setAttribute('reveal', 'auto');
        const ready = () => {
          clearTimeout(this.loadTimer);
          const supported = viewer.canActivateAR;
          this.launch.hidden = !supported;
          this.launch.disabled = !supported;
          this.status.textContent = mobile ? (supported ? this.status.dataset.ready : this.status.dataset.unsupported) : '';
        };
        viewer.addEventListener('load', ready, { signal: this.controller.signal });
        viewer.addEventListener('error', () => {
          clearTimeout(this.loadTimer);
          this.status.textContent = this.status.dataset.error;
          this.launch.hidden = true;
          viewer.remove();
          this.viewer = null;
        }, { signal: this.controller.signal });
        viewer.addEventListener('ar-status', event => {
          if (event.detail.status === 'failed') this.status.textContent = this.status.dataset.error;
        }, { signal: this.controller.signal });
        this.viewer = viewer;
        this.querySelector('[data-ar-viewer]').replaceChildren(fragment);
        this.loadTimer = setTimeout(() => {
          if (!viewer.loaded) this.status.textContent = this.status.dataset.error;
        }, 25000);
      } catch {
        this.status.textContent = this.status.dataset.error;
      }
    }
  });
}
